import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import get from 'lodash/get';
import classNames from 'classnames';

import { StandardBtn, PremiumBtn, FreeBtn } from 'rebook/apps/base/components/BtnSubscriptionIcon';
import BookCover from 'rebook/apps/books/components/BookCover';
import BookRating from 'rebook/apps/books/components/BookRating';
import { BOOK_STATUSES_TITLE } from 'rebook/apps/books/constants';
import MultilineEllipsisText from 'rebook/apps/base/components/MultilineEllipsisText';
import { Author } from 'rebook/apps/catalog/models';
import { Book } from 'rebook/apps/books/models';
import uaDetector from 'rebook/apps/utils/uaDetector';

import styles from './style.scss';


const ContextBookCardLong = ({
  book, order, isAudio, shouldShowAvailable,
  linkCallback,
}) => {
  const {
    rating: bookRating,
    reading_status: readingStatus,
  } = book;

  const subscriptionTypes = {
    standard: 1,
    pro: 2,
    audio: 3,
  };

  book = new Book(book);
  const bookType = get(book, 'type', 'text');
  const mainAuthor = book.main_author ? new Author(book.main_author) : null;
  const isAudioBook = bookType === 'audio' || isAudio;
  const bookAnotation = book.annotation_short;
  const mapReadingStatus = readingStatus || 0;
  const status = bookType.length ? BOOK_STATUSES_TITLE[bookType][mapReadingStatus] : '';
  const isAvailableOnlyUser = get(book, 'available_for_user_only', false);
  const isMobile = uaDetector.isMobile(navigator && navigator.userAgent ? navigator.userAgent : null);
  const audioBookImageHeight = isAudioBook ? '112' : '180';
  const imageSizes = {
    width: isMobile ? '88' : '112',
    height: isMobile ? '141' : audioBookImageHeight,
  };

  return (
    <div className={styles.book}>
      <div className={styles.bookWrapper}>
        <div className={styles.bookCover}>
          {shouldShowAvailable
            ? (
              <BookCover
                book={book}
                isAvailableOnlyUser={isAvailableOnlyUser}
                linkCallback={linkCallback}
                isAudioBook={isAudioBook}
                width={imageSizes.width}
                height={imageSizes.height} />
            )
            : (
              <BookCover
                book={book}
                isAudioBook={isAudioBook}
                width={imageSizes.width}
                height={imageSizes.height} />
            )
          }
        </div>
        <div className={styles.bookDetail}>
          <div className={styles.bookData}>
            {(order > 0 || status) && (
              <div className={styles.info}>
                {order > 0
                  ? <div className={styles.bookOrder}>{order}</div>
                  : null
                }
                {status
                  ? <div className={styles.bookStatus}>{status}</div>
                  : null
                }
              </div>
            )}
            <div className={styles.bookTitle}>
              <Link to={book.getLink()}>
                <MultilineEllipsisText maxLinesCount={2}>{book.name}</MultilineEllipsisText>
              </Link>
            </div>
            {mainAuthor && (
              <Link to={mainAuthor.getLink()} className={styles.bookAuthor}>
                <MultilineEllipsisText maxLinesCount={3}>{mainAuthor.cover_name}</MultilineEllipsisText>
              </Link>
            )}
          </div>
          <div className={styles.bookTools}>
            <div className={styles.bookRating}>
              <BookRating
                value={bookRating.rating}
                isTiny
                showNumericValue
                votes={bookRating.votes} />
            </div>
            {(book.subscription_id === subscriptionTypes.pro || book.subscription_id === subscriptionTypes.audio) && (
              <div className={styles.subscriptionContainer}>
                <PremiumBtn width="32" height="32" />
              </div>
            )}
            {book.subscription_id === subscriptionTypes.standard && (
              <div className={styles.subscriptionContainer}>
                <StandardBtn width="28" height="28" />
              </div>
            )}
            {!book.subscription_id && (
              <div className={styles.subscriptionContainer}>
                <FreeBtn />
              </div>
            )}
          </div>
          <div className={classNames(styles.bookDescription, 'jest-context-book-card-long')}>
            {bookAnotation}
            <Link to={book.getLink()}>
              <span className={styles.link}>
                ⟩
              </span>
            </Link>
          </div>
        </div>
      </div>
      <div className={styles.bookDescriptionMobile}>
        {bookAnotation}
        <Link to={book.getLink()}>
          <span className={styles.link}>
          ⟩
          </span>
        </Link>
      </div>
    </div>
  );
};

ContextBookCardLong.propTypes = {
  book: PropTypes.shape({
    absolute_url: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    read_count: PropTypes.number,
    main_author: PropTypes.shape({
      cover_name: PropTypes.string,
      absolute_url: PropTypes.string,
    }),
    rating: PropTypes.shape({
      rating: PropTypes.number.isRequired,
      votes: PropTypes.number.isRequired,
    }).isRequired,
    order: PropTypes.number,
  }),
  order: PropTypes.number,
  shouldShowAvailable: PropTypes.bool,
  handleDelete: PropTypes.func,
};

ContextBookCardLong.defaultProps = {
  order: null,
  shouldShowAvailable: false,
};

export default ContextBookCardLong;
